import * as GENERAL_ACTION from 'js/constant/action/general'
import { createAction } from 'redux-actions'
import _ from 'lodash'

const enableDarkMode = createAction(GENERAL_ACTION.ENABLE_DARK_MODE)

export const setDarkMode = () => async (dispatch) => {
  dispatch(enableDarkMode())
}